{"messages":{"previous":"Wstecz","next":"Dalej","today":"Dzisiaj","month":"Miesiąc","week":"Tydzień","list":"Lista","day":"Dzień"}}